const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

const round2 = (n) => Math.round(n * 100) / 100;

/** Area an area-based extra charge is applied to: super build-up, falling back to build-up. */
export const accommodationChargeArea = (acc) =>
  num(acc?.superBuildUpArea ?? acc?.super_build_up_area) ||
  num(acc?.buildUpArea ?? acc?.build_up_area);

const chargeAccommodationIds = (charge) =>
  (charge?.accomodations || [])
    .map((a) => Number(a?.accomodation_id ?? a?.accomodation?.id))
    .filter(Number.isFinite);

/**
 * Total of one extra charge across every unit of the accommodations it is attached to.
 * 'accommodation' mode: flat price per unit. 'sqft' / 'sqmt' mode: price x the unit's area.
 * Returns one row per accommodation plus the project-wide totals (GST shown separately).
 */
export const computeExtraChargeTotals = (charge, units, accommodationsById) => {
  const price = num(charge?.price);
  const gstPct = num(charge?.gst);
  const areaBased = charge?.mode === 'sqft' || charge?.mode === 'sqmt';

  const unitsByAcc = new Map();
  (units || []).forEach((u) => {
    const id = Number(u?.accomodation_id);
    if (!Number.isFinite(id)) return;
    unitsByAcc.set(id, (unitsByAcc.get(id) || 0) + 1);
  });

  const rows = chargeAccommodationIds(charge).map((accId) => {
    const acc = accommodationsById.get(accId);
    const unitCount = unitsByAcc.get(accId) || 0;
    const area = areaBased ? accommodationChargeArea(acc) : null;
    const perUnit = areaBased ? price * area : price;
    const subtotal = perUnit * unitCount;
    const gst = (subtotal * gstPct) / 100;
    return {
      accId,
      name: acc?.name || `Accommodation ${accId}`,
      unitCount,
      area,
      perUnit: round2(perUnit),
      subtotal: round2(subtotal),
      gst: round2(gst),
      total: round2(subtotal + gst),
      missingArea: areaBased && !area
    };
  });

  const sum = (key) => round2(rows.reduce((s, r) => s + r[key], 0));
  return {
    areaBased,
    gstPct,
    rows,
    unitCount: rows.reduce((s, r) => s + r.unitCount, 0),
    subtotal: sum('subtotal'),
    gst: sum('gst'),
    total: sum('total'),
    hasMissingArea: rows.some((r) => r.missingArea)
  };
};
